import { render } from "./vh-booking-calendar.vue?vue&type=template&id=037fb7ae"
import script from "./vh-booking-calendar.vue?vue&type=script&lang=js"
export * from "./vh-booking-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__